import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rootRoute } from './root-route';

/** Dev-only UI kit gallery (router.tsx registers it only in `vite dev`). */
export const uiKitRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/_ui',
  // the DEV guard drops the gallery chunk from production builds entirely
  component: import.meta.env.DEV
    ? lazyRouteComponent(() => import('./UiKitPage'), 'UiKitPage')
    : () => null,
});
